/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  LoginDto,
  LoginResponseDto,
  LoginResponseUserBodyLoginResponseDto,
} from '../models/index';
import {
    LoginDtoFromJSON,
    LoginDtoToJSON,
    LoginResponseDtoFromJSON,
    LoginResponseDtoToJSON,
    LoginResponseUserBodyLoginResponseDtoFromJSON,
    LoginResponseUserBodyLoginResponseDtoToJSON,
} from '../models/index';

export interface AuthenticationLoginPOSTRequest {
    loginDto?: LoginDto;
}

/**
 * AuthenticationApi - interface
 * 
 * @export
 * @interface AuthenticationApiInterface
 */
export interface AuthenticationApiInterface {
    /**
     * Creates request options for authenticationLoginPOST without sending the request
     * @param {LoginDto} [loginDto] 
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    authenticationLoginPOSTRequestOpts(requestParameters: AuthenticationLoginPOSTRequest): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {LoginDto} [loginDto] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    authenticationLoginPOSTRaw(requestParameters: AuthenticationLoginPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoginResponseUserBodyLoginResponseDto>>;

    /**
     */
    authenticationLoginPOST(requestParameters: AuthenticationLoginPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoginResponseUserBodyLoginResponseDto>;

    /**
     * Creates request options for authenticationLogoutPOST without sending the request
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    authenticationLogoutPOSTRequestOpts(): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    authenticationLogoutPOSTRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     */
    authenticationLogoutPOST(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for authenticationRefreshTokenPOST without sending the request
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    authenticationRefreshTokenPOSTRequestOpts(): Promise<runtime.RequestOpts>;

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationApiInterface
     */
    authenticationRefreshTokenPOSTRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoginResponseUserBodyLoginResponseDto>>;

    /**
     */
    authenticationRefreshTokenPOST(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoginResponseUserBodyLoginResponseDto>;

}

/**
 * 
 */
export class AuthenticationApi extends runtime.BaseAPI implements AuthenticationApiInterface {

    /**
     * Creates request options for authenticationLoginPOST without sending the request
     */
    async authenticationLoginPOSTRequestOpts(requestParameters: AuthenticationLoginPOSTRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/api/Authentication/login`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LoginDtoToJSON(requestParameters['loginDto']),
        };
    }

    /**
     */
    async authenticationLoginPOSTRaw(requestParameters: AuthenticationLoginPOSTRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoginResponseUserBodyLoginResponseDto>> {
        const requestOptions = await this.authenticationLoginPOSTRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginResponseUserBodyLoginResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async authenticationLoginPOST(requestParameters: AuthenticationLoginPOSTRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoginResponseUserBodyLoginResponseDto> {
        const response = await this.authenticationLoginPOSTRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for authenticationLogoutPOST without sending the request
     */
    async authenticationLogoutPOSTRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Authentication/logout`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async authenticationLogoutPOSTRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.authenticationLogoutPOSTRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async authenticationLogoutPOST(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.authenticationLogoutPOSTRaw(initOverrides);
    }

    /**
     * Creates request options for authenticationRefreshTokenPOST without sending the request
     */
    async authenticationRefreshTokenPOSTRequestOpts(): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/Authentication/refresh`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async authenticationRefreshTokenPOSTRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoginResponseUserBodyLoginResponseDto>> {
        const requestOptions = await this.authenticationRefreshTokenPOSTRequestOpts();
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginResponseUserBodyLoginResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async authenticationRefreshTokenPOST(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoginResponseUserBodyLoginResponseDto> {
        const response = await this.authenticationRefreshTokenPOSTRaw(initOverrides);
        return await response.value();
    }

}
